import React from 'react';
import Form from 'react-bootstrap/Form';

const SwitchToggle = ({ status, onToggle }) => {
  return (
    <Form className='custom_switch_form'>
      <Form.Check 
        type="switch"
        id="custom_switch"
        label={status ? "" : ""}
        checked={status}
        onChange={onToggle}
      />
    </Form>
  );
};

export default SwitchToggle;
